<template>
  <div class="scrollbar-wrapper">

    <el-menu
      mode="vertical"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      :collapse="isCollapse"
      :default-active="$route.path"
      :unique-opened="true"
    >
      <template v-for="(item, index) in menuList">
        <el-submenu :index="index+''" :key="index" style="position: relative">
          <!--    导航大类      -->
          <template slot="title" >
            <i v-if="item.parent.icon" :class="item.parent.icon"></i>
            <span>{{ item.parent.name }}</span>
            <div v-if="checkIsTabBarUrl(item.parent.url,1) && checkIsTabBarUrl(item.parent.url,1).number > 0 && refresh" class="optionsIcon" :class="[isCollapse ? 'optionsIconAc':'']">{{checkIsTabBarUrl(item.parent.url,1).number}}</div>
          </template>
          <!--     导航大类对应的子类     -->
          <template v-for="child in item.sonItem">
            <el-menu-item :index="child.url" :key="child.name" v-if="child.show" @click="navigatorTo(child)" style="position: relative">
              <i v-if="child.icon" :class="child.icon"></i>
              <span>{{ child.name }}</span>
              <div class="optionsIconRight" v-if="checkIsTabBarUrl(child.url,2) && checkIsTabBarUrl(child.url,2).number > 0 && refresh">{{checkIsTabBarUrl(child.url,2).number}}</div>
            </el-menu-item>
          </template>
        </el-submenu>
      </template>


    </el-menu>


  </div>
</template>

<script>
import {adminUserApi} from "@/api/adminUser";
export default {
  name: "Sidebar",
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    isCollapse: {
      type: Boolean,
      default: () => false
    },
  },
  components: {},
  data() {
    return {
      refresh:true,
      mainMenu:{
        audits: '',
        orders: '',
        rewardOrders: '',
        users: ''
      },
      subMenu:{
        nurseEarnings:'',
        professionPendingCount:'',
        orgPendingCount:'',
        pendingOrdersCount:'',
        pendingShipmentCount:'',
        referralRewards:'',
        unreadSuggestionsCount:'',
      }
    }
  },
  methods: {
    async getList(){
      let res = await  adminUserApi.realTimeStatistics()
      if(res.data.code == 1){
        this.subMenu = res.data.data.subMenu
        this.mainMenu = res.data.data.mainMenu
        this.refresh = false
        setTimeout(()=>{
          this.refresh = true
        },1)
      }
    },
    checkIsTabBarUrl(url,type){
      const patterns = type === 1
        ? [
          { path: "/users", number: this.mainMenu.users },
          { path: "/order", number: this.mainMenu.orders },
          { path: "/examine", number: this.mainMenu.audits },
          { path: "/rewardStore", number: this.mainMenu.rewardOrders },
        ]
        : [
          { path: "/examine/professionApply", number: this.subMenu.professionPendingCount },
          { path: "/examine/orgApply", number: this.subMenu.orgPendingCount },
          { path: "/users/complaintSuggestionList", number: this.subMenu.unreadSuggestionsCount },
          { path: "/order/list", number: this.subMenu.pendingOrdersCount },
          { path: "/examine/cashout", number: this.subMenu.nurseEarnings },
          { path: "/examine/promotionCashOut", number: this.subMenu.referralRewards },
          { path: "/rewardStore/orderList", number: this.subMenu.pendingShipmentCount },
        ];
      return patterns.find(item => item.path === url) || false;
    },
    navigatorTo(item) {
      this.$emit('navigatorTo', item)
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.getList()
    if (systemParams.realTimeStatistics === 1) {
      setInterval(()=>{
        this.getList()
      },1000*10)
    }
  }
}
</script>

<style scoped lang="scss">
@import "Sidebar.scss";
.optionsIcon{
  position: absolute;
  top: 10px;
  right: 50px;
  background: red;
  height: 20px;
  min-width: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
}
.optionsIconAc{
  right: 0px;
}
.optionsIconRight{
  position: absolute;
  top: 5px;
  right: 20px;
  background: red;
  height: 20px;
  min-width: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  padding: 2px 0;
}
</style>
